import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import iconSalud from "../../assets/img/health.png";
import iconVida from "../../assets/img/life.png";
import { FaWhatsapp } from "react-icons/fa";

const Proteccion = () => {
  return (
    <section className="proteccion-docentes py-5">
      <Container>
        <Row>
          <Col md={11} className="mx-auto text-center mb-4">
            <Container>
              <Row className="align-items-start">
                <Col md={12} className="text-start">
                  <span className="badge-colegios">Colegios</span>
                </Col>
              </Row>

              <Row className="align-items-start pb-5">
                <Col md={6} className="text-start">
                  <h2 className="fw-bold text-primary display-6 mb-3 text-start pb-4">
                    Su vocación
                    <br />
                    merece protección
                  </h2>
                </Col>
                <Col md={6}>
                  <p className="text-start pt-3">
                    En MCBrokers creemos en la importancia de cuidar a quienes educan. Por ello, hemos desarrollado un{" "}
                    <strong>Programa especial para docentes</strong>, que les brinda la posibilidad de acceder a
                    servicios de <strong>salud</strong> y<strong> protección de vida</strong> a un costo accesible.
                    <br />
                    Los docentes podrán contar con:
                  </p>
                </Col>
              </Row>

              <Row className="gy-4 mb-5">
                <Col md={6} className=" mb-md-0 mb-5">
                  <div className="box-card text-start  shadow-sm h-100">
                    <div className="icon-wrapper">
                      <img src={iconSalud} alt="Protección salud" />
                    </div>
                    <h5 className="fw-bold">Protección de salud</h5>
                    <p className="mb-0">
                      Una protección de gastos médicos mayores con una suma asegurada por $3,000,000 (extensivo a
                      familiares directos).
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="box-card text-start  shadow-sm h-100">
                    <div className="icon-wrapper">
                      <img src={iconVida} alt="Protección vida" />
                    </div>
                    <h5 className="fw-bold">Protección vida</h5>
                    <p className="mb-0">Seguridad para su familia ante los eventos inesperados de la vida.</p>
                  </div>
                </Col>
              </Row>

              <div className="text-md-center text-start">
                <p className="mb-3 accordion text-start text-md-center">
                  Si estás interesado, da clic aquí y permítenos <br className="d-md-block d-none" /> asesorarte
                  mediante una llamada o videollamada.
                </p>
                <a
                  href="https://api.whatsapp.com/send?phone=5215552030377&text=Hola%2C%20solicito%20informaci%C3%B3n%20detallada%20sobre%20el%20Programa%20Especial%20para%20Colegios.%20Vi%20la%20info%20en%20su%20Portal%20Web.%20%F0%9F%8C%90"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-comunicate d-inline-flex align-items-center gap-2 mt-3 boton-hogar"
                >
                  <FaWhatsapp />
                  Quiero comunicarme
                </a>
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Proteccion;
